import './CardImage.scss';

import { Card, Image } from '@icarros/torque-react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class CardImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imageOrientation: 'portrait'
    };

    this.onImageLoad = this.onImageLoad.bind(this);
    this.imageRef = React.createRef();
  }

  onImageLoad() {
    this.setState({
      imageOrientation: this.imageRef.current.getImageOrientation()
    });
  }

  render() {
    const { imageUrl, children, flat } = this.props;
    const { imageOrientation } = this.state;

    return (
      <Card className="card-image" flat={flat}>
        <div className="card-image__content">
          <div
            className={classNames('card-image__main-photo-container', {
              [`card-image__main-photo-container--${imageOrientation}`]: imageOrientation
            })}
          >
            <Image
              className={classNames('card-image__main-photo', {
                [`card-image__main-photo--${imageOrientation}`]: imageOrientation
              })}
              onLoad={this.onImageLoad}
              src={imageUrl}
              ref={this.imageRef}
            />
          </div>
          <div className="card-image-main">{children}</div>
        </div>
      </Card>
    );
  }
}

CardImage.propTypes = {
  imageUrl: PropTypes.string,
  children: PropTypes.element,
  flat: PropTypes.bool
};

CardImage.defaultProps = {
  flat: false
};

export default CardImage;
